/**
 * Copyright 2016 xdot GmbH
 * Author: Carsten Hibbeler
 * Date: 28.01.2016
 *
 */

'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { AppContext, Title } from 'plugin/liferay-widgets-react-web';
import { BusinessObjectMultiSelect } from 'plugin/base-portlet';

import { getFliwasOrganizationStore } from '../stores/StoreFactory';
import FliwasOrganizationActions from '../actions/FliwasOrganizationActions';
import FliwasOrganizationMapLinkListItem from '../map/FliwasOrganizationMapLinkListItem';
import { ClassNames } from '../constants/Constants';

const FliwasOrganizationStore = getFliwasOrganizationStore(AppContext);

let optionsSec = [];
for (let i = 0 ; i <= 60 ; i++) {
    optionsSec.push(<option value={i * 1000}>{i}</option>);
}

class FliwasMultiOrganizationConfigForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchValue: ''
        };
    }

    search(dataName, query) {
        FliwasOrganizationActions.search(dataName, query);
    }

    listActive(dataName, query) {
        FliwasOrganizationActions.itemsByGroupIds(dataName, {
            ...query,
            groupIds: query.activeIds
        });
    }

    render() {
        return (
            <React.Fragment>
                <Title title="Mandanten auswählen" className="noborder"/>
                <BusinessObjectMultiSelect
                    formId={this.props.formId}
                    formData={this.props.formData}
                    onChange={this.props.onChange}
                    className={ClassNames.Group}
                    propName="activeOrganizationIds"
                    onMore={FliwasOrganizationActions.moreItems}
                    onSearch={this.search.bind(this)}
                    onListActive={this.listActive.bind(this)}
                    CustomActiveListMapLinkListItem={FliwasOrganizationMapLinkListItem}
                    CustomAllListMapLinkListItem={FliwasOrganizationMapLinkListItem}
                    store={FliwasOrganizationStore}
                    selectedListTitle="Ausgewählte Mandanten"
                />
            </React.Fragment>
        );
    }
}

FliwasMultiOrganizationConfigForm.propTypes = {
    onChange: PropTypes.func,
    formId: PropTypes.string,
    formData: PropTypes.object
};

export default FliwasMultiOrganizationConfigForm;



// WEBPACK FOOTER //
// ./js/widgets/FliwasMultiOrganizationConfigForm.jsx